import { createSettingMutation } from '@/graphql/mutation';
import { settingsQuery } from '@/graphql/query';
import { useMutation, useSuspenseQuery } from '@apollo/client';

type Settings = {
  canSupportLogin?: boolean;
  marketplaceNotificationMail?: string;
  mainTour?: boolean;
};

export const useSettings = () => {
  const { data } = useSuspenseQuery<{ settings: Settings }>(settingsQuery, {
    fetchPolicy: 'cache-and-network'
  });

  const settings = data?.settings ?? {};

  const [updateSettings, { loading: updating }] = useMutation(createSettingMutation, {
    refetchQueries: ['Settings'] // for each settingsQuery
  });

  return {
    settings,
    updatingSettings: updating,
    setSettings: (settings: Settings) =>
      updateSettings({
        variables: {
          settings
        }
      })
  };
};
